module.exports = __webpack_public_path__ + "img/C07TechThrowingAxemanChampion_ua.568d9e58.webp";